import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.167 2.5a3.333 3.333 0 1 1 0 6.667 3.333 3.333 0 0 1 0-6.667zm0 8.333c3.683 0 6.666 1.492 6.666 3.334v1.666H2.5v-1.666c0-1.842 2.983-3.334 6.667-3.334z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD3127",
    cx: "15",
    cy: "15",
    r: "5"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: "15",
    cy: "15",
    r: "3.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD3127",
    d: "m12.054 16.768 4.714-4.714 1.178 1.178-4.714 4.714z"
  })));
});